export default __webpack_public_path__ + "static/media/icon58white.8a054a03.svg";